module.exports = __webpack_public_path__ + "img/32.0521c38b.png";